"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaLoader = void 0;
var _logger = require("@ori/logger");
var _react = _interopRequireWildcard(require("react"));
var _TopAreaSkeleton = require("./TopAreaSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } /*
 * This wrapper ensures that even with an error in the TopArea.tsx file, the rest of the page
 * will still render and this will not be shown. This will also show skeleton while loading TopArea.tsx file.
 */
const TopArea = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require('./TopArea'))).then(module => ({
  default: module.TopArea
})));
const TopAreaLoader = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
  areaName: "TopAreaLoader",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopAreaSkeleton.TopAreaSkeleton, {}),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TopArea, {})
  })
});
exports.TopAreaLoader = TopAreaLoader;
